import { IMAGES } from "./images"

export const NavItem_Course=[
    {
        
        title:"Courses",
        data:[
          {
            icon:IMAGES.COURSE_ICON_1,
            name:"Banking and Finance",
            courses:[
              {
                heading:"Program In Relationship Management",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/banking_page-1"
        
              },
              {
                heading:"Relationship Management for Under Graduates",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/banking_page-2"
        
              },
              {
                heading:"Program in Banking Sales & Relationship Management",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/banking_page-3"
              },
              {
                heading:"Banking Sales and Relationship Management for Under Graduates",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/banking_page-4"
              },
            ]
          },
          {
            icon:IMAGES.COURSE_ICON_2,
            name:"Software Engineering",
            courses:[
              {
                heading:"Full-Stack Development",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-1"
              },
              {
                heading:"Master JavaScript",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-2"
              },
              {
                heading:"Frontend Development with React Js",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-3"
        
              },
              {
                heading:"Mobile Development",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-4"
        
              },
              {
                heading:"Software Testing",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-5"
        
              },
              {
                heading:"Java Development",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-6"
        
              },
              {
                heading:"Automation Testing",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-7"
        
              },
              {
                heading:"Power Bi",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-8"
        
              },
              {
                heading:"Game Development",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/software_page-9"
        
              },
            ]
          },
          {
            icon:IMAGES.COURSE_ICON_3,
            name:"Data Science",
            courses:[
              {
                heading:"Data Science and ML",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/datascience_page-1"
              },
              {
                heading:"Artificial Intelligence and Machine Learning",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/datascience_page-2"
        
              },
              {
                heading:"Data Analytics using Python and SQL",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/datascience_page-3"
        
              },
              {
                heading:"Artificial Intelligence Engineer",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/datascience_page-4"
        
              },
            ]
          },
          {
            icon:IMAGES.COURSE_ICON_4,
            name:"Digital Marketing",
            courses:[
              {
                heading:"Digital Marketing with GenAI",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/digitalmarketing_page-1"
              },
              {
                heading:"SEO and Growth Marketing ",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/digitalmarketing_page-2"
        
              },
              {
                heading:"Social Media and Influencer Marketing",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/digitalmarketing_page-3"
        
              },
              {
                heading:"Email Marketing",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/digitalmarketing_page-4"

        
              },
              {
                heading:"Content Marketing",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"/digitalmarketing_page-5"

        
              },
            ]
          },
          {
            icon:IMAGES.COURSE_ICON_5,
            name:"Cyber Security",
            courses:[
              {
                heading:"Cyber Security for Beginners ",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"cyber_page-1"
        
              },
              {
                heading:"Advanced Cyber Security",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"cyber_page-2"
              },
             
              
            ]
          },
          {
            icon:IMAGES.COURSE_ICON_6,
            name:"Cloud Computing",
            courses:[
              {
                heading:"IT SysAdmin & Cloud Computing Program ",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"cloud_page-1"
              }
              
            ]
          },
          {
            icon:IMAGES.COURSE_ICON_7,
            name:"Certification",
            courses:[
              {
                heading:"Python Certification Program",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"certification_page-1"
              },
              {
                heading:"Java Certification Program",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                 link:"certification_page-2"
              },
              {
                heading:"AWS Certification Program",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                 link:"certification_page-3"
        
              },
              {
                heading:"Microsoft Azure Certification Program",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                 link:"certification_page-4"
        
              },
              {
                heading:"Salesforce Certification Program",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                 link:"certification_page-5"
        
              },
            ]
          },
          {
            icon:IMAGES.COURSE_ICON_8,
            name:"Design",
            courses:[
              {
                heading:"UI & UX Design",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"design_page-1"
              },
              {
                heading:"Graphic Design",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"design_page-2"
        
              },
              {
                heading:"Product Design",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"design_page-3"
        
              },
            
            ]
          },
          {
            icon:IMAGES.COURSE_ICON_9,
            name:"Agile and Scrum",
            courses:[
              {
                heading:"Certified Scrum Master (CSM)",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"agile_page-1"
              },
              {
                heading:"Professional Scrum Product Owner",
                duration:"34 weeks",
                mode:"Live Online",
                oppurtunity:"Placement Opportunities",
                duration_icon:IMAGES.CALENDER_ICON,
                mode_Icon:IMAGES.LIVE_ICON,
                oppurtunity_icon:IMAGES.VERIFIED_ROUNDED_ICON,
                link:"agile_page-2"
        
              },
              
            
            ]
          },
        ],
    }
]

export const NavItem_Training=[
    {
        title:"Trainings",
        links: [
        { to: "/long-term-trainings", label: "Long-Term Trainings" },
        { to: "/short-term-trainings", label: "Short-Term Trainings" },
      ]
    }
]

